// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__o5fBE","rootMobile":"styles_rootMobile__vgNwt"};